export default {
  downtimeUrl: "https://www.kodland.org/es",
  parameters: {
    landing_id: "LatFwdT",
    segment: 53,
  },
  startPage: {
    image: "/welcome/fwd_tab_desk.png",
    imageMobile: "/welcome/fwd_tab_mob.png",
    title:
      "Responde estas 5 preguntas y recibe una clase gratuita para tu hijo/a",
    subtitle:
      "Tu hijo dominará el dibujo digital en una tableta y explorará otras habilidades creativas como la animación, la ilustración, el modelado en 3D y el diseño.",
    button: "Presiona para continuar 🚀",
  },
  successPage: {
    title: "¡Felicitaciones! 🎁",
    subtitle: "Haz clic en '📆 Reservar una clase' para completar el registro",
    button: "📆 Reservar una clase",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title:
      "¡Gracias por confiar en nuestra plataforma educativa! Para participar en la clase gratuita, se necesita una computadora o laptop. ¡Esperamos verte en otra ocasión!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "¿Te gustaría que el tiempo que tu hijo pasa frente a la computadora o tablet sea más productivo?",
      answers: [
        "🔥 ¡Si!",
        "🤗 No. Lo hace solo para divertirse y eso está bien",
      ],
    },
    2: {
      question:
        "¿Qué habilidades tiene tu hijo con la computadora o laptop?",
      answers: [
        "👍 Aún no tiene experiencia, necesita aprender lo básico",
        "🙌 Nivel básico — usa PowerPoint y apps básicas",
        "💻 Nivel intermedio — usuario confiado, quiere explorar más",
        "🕹 Principalmente usa computadora o tableta para jugar",
      ],
    },
    3: {
      question:
        "¿Tienen una tablet en casa?",
      answers: [
        "📱 Sí, tenemos un iPad",
        "🤖 Sí, tenemos una tablet Android",
        "🛒 Planeamos comprar una tablet",
        "🚫 No planeamos comprar una tablet"
      ],
    },
    4: {
      question:
        "¿Tienes una laptop o computadora donde puedas trabajar?",
      answers: [
        "💻 Sí",
        {
          answer: "😐 No",
          stopAnswer: true,
        },
      ],
    },
  },
};
